// Logic for when + Parts finder is clicked  and  menu opens the parts finder tab is open and shop all is closed 

const activeFinder = document.querySelectorAll('.jsActiveFinder'); 
const activeSearch = document.querySelectorAll('.jsActiveSearch'); 
const activeShop = document.querySelectorAll('.jsActiveShop'); 
const shopProds = document.getElementById('jsShopAll');
const shopProdsContent = document.getElementById('jsShopContent');
const finder = document.getElementById('jsFinder');
const finderContent = document.getElementById('jsFinderContent');


activeFinder.forEach(tab => {
    tab.addEventListener('click', () => {
        shopProds.classList.remove('activeClass');
        shopProdsContent.classList.remove('activeClass');
        finderContent.classList.add('activeClass');
        finder.classList.add('activeClass');
    });
});

activeSearch.forEach(tab => {
    tab.addEventListener('click', () => {
        shopProds.classList.add('activeClass');
        shopProdsContent.classList.add('activeClass');
        finderContent.classList.remove('activeClass');
        finder.classList.remove('activeClass');
    });
});

activeShop.forEach(tab => {
    tab.addEventListener('click', () => {
        shopProds.classList.add('activeClass');
        shopProdsContent.classList.add('activeClass');
        finderContent.classList.remove('activeClass');
        finder.classList.remove('activeClass');
    });
});